import React, { useEffect, useState } from 'react';
import AddNewRole from 'src/components/Roles/AddNewRole';
import HeaderContentBlock from 'src/components/Common/HeaderContentBlock';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import ResponsiveHeaderContentBlock from 'src/components/Responsive/ResponsiveHeaderContentBlock';
import { rolePermissionList } from 'src/services/rolesPermission';
import { breakPoints } from 'src/constants/general';
import ModalContentBlock from 'src/components/Common/ModalContentBlock';
import { useDeviceDetect } from 'src/hooks/useDeviceDetect';
import AddRolePermission from './AddRolePermission/index';

const RolesPermission = () => {
    const [addNewRole, setAddNewRole] = useState(false);
    const [isSave, setIsSave] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [searchInput, setSearchInput] = useState('');
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [roleListData, setRoleListData] = useState([]);
    const [totalRoleRecords, setTotalRoleRecords] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false);
    const [selectedRowData, setSelectedRowData] = useState<any>(null);
    const { isMobile }: any = useDeviceDetect();
    const [modalOpen, setModalOpen] = useState(false);

    const controller = new AbortController();

    useEffect(() => {
        if (searchInput) {
            getRoleList(`?page=${page}&limit=${rows}&search=${searchInput}`, controller.signal);
        } else {
            getRoleList(`?page=${page}&limit=${rows}`, controller.signal);
        }
        return () => controller.abort();
    }, [page, rows, searchInput]);

    const getRoleList = async (url: string, signal?: any) => {
        try {
            setIsLoading(true);
            const roleResData = await rolePermissionList(url, signal);
            const data = roleResData?.data?.data;
            setRoleListData(data.rolePermissions);
            setTotalRoleRecords(data.total);
            setIsLoading(false);
        } catch (error) {
            setIsLoading(false);
        }
    };

    const handleSearch = (e: any) => {
        setPage(0);
        setSearchInput(e.target.value);
    };
    const newRoleSuccess = () => {
        if (page === 0) {
            getRoleList(`?page=${page}&limit=${rows}`, controller.signal);
        } else {
            setPage(0);
            setFirst(0);
        }
        setAddNewRole(false);
        setBtnDisabled(false);
        setIsUpdate(false);
        setSelectedRowData(null);
    };
    const onPageChange = (event: any) => {
        setFirst(event.first);
        setRows(event.rows);
        setPage(event.page);
    };

    const GetPermissions = (row: any) => <div>{!row?.permissions ? '-' : row.permissions}</div>;
    const GetDisplayName = (row: any) => <div>{row?.display_name}</div>;
    const handleEditAction = (row: any) => (
        <div
            onClick={async (e) => {
                e.stopPropagation();
                setModalOpen(true);
                setSelectedRowData(row);
                // handleVoucherSave(row);
            }}
            className={`h-7 min-w-[70px] py-1 text-white border-2 rounded-lg justify-center items-center inline-flex 
               'cursor-pointer bg-primary border-primary'
            `}
        >
            <p className="text-sm font-medium">Edit</p>
        </div>
    );

    return (
        <div>
            <div className={`${modalOpen ? 'hidden' : 'max-lg:block hidden'}`}>
                <ResponsiveHeaderContentBlock
                    sortOnClick={() => {}}
                    closeOnClick={() => {
                        setAddNewRole(false);
                        setSelectedRowData(null);
                        setIsUpdate(false);
                    }}
                    addNewOnClick={() => setAddNewRole(true)}
                    isDisabled={addNewRole}
                    searchOnchange={handleSearch}
                    searchInput={searchInput}
                    isNext={addNewRole}
                />
            </div>
            <HeaderContentBlock
                closeOnClick={() => {
                    setAddNewRole(false);
                    setSelectedRowData(null);
                    setIsUpdate(false);
                }}
                saveOnClick={() => setIsSave(true)}
                addNewOnClick={() => setAddNewRole(true)}
                nextStep={addNewRole}
                addNewBtnText={'Add new Role'}
                isEmploy={true}
                headerText="Role Permissions"
                isDisabled={btnDisabled}
                searchOnchange={handleSearch}
                searchInput={searchInput}
                // sortOnClick={() => {}}
            />
            {addNewRole && (
                <AddNewRole
                    setIsSave={setIsSave}
                    isSave={isSave}
                    isOnSuccess={() => {
                        newRoleSuccess();
                    }}
                    setBtnDisabled={setBtnDisabled}
                    btnDisabled={btnDisabled}
                    isUpdate={isUpdate}
                    selectedRowData={selectedRowData}
                />
            )}
            <div className={`pt-5 pb-0 w-full ${addNewRole || modalOpen ? 'hidden' : 'max-lg:block hidden'}`}>
                <>
                    <div className="py-6 lg:block">
                        <DataTable value={roleListData} tableClassName="logdatatable" emptyMessage="No Role Found" className="" loading={isLoading}>
                            <Column field="display_name" header="Role" body={GetDisplayName}></Column>
                            <Column field="permissions" header="Permissions" body={GetPermissions}></Column>
                            <Column field="created_at" header="Created Date" body={handleEditAction}></Column>
                        </DataTable>
                        <Paginator
                            first={first}
                            rows={rows}
                            totalRecords={totalRoleRecords}
                            onPageChange={onPageChange}
                            className="datatable_pagination"
                            template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                        />
                    </div>
                </>
            </div>
            {modalOpen && isMobile < breakPoints.tablet && (
                <div className={`${modalOpen ? 'max-lg:block hidden' : 'hidden'}`}>
                    <AddRolePermission getRoleList={getRoleList} selectedRowData={selectedRowData} setModalOpen={setModalOpen} rolePage={page} isResponsive={true} />
                </div>
            )}

            <div className="py-6 lg:block max-lg:hidden">
                <DataTable value={roleListData} tableClassName="logdatatable" emptyMessage="No Role Found" className="" loading={isLoading}>
                    <Column field="display_name" header="Role" body={GetDisplayName}></Column>
                    <Column field="permissions" header="Permissions" body={GetPermissions}></Column>
                    <Column field="created_at" header="Created Date" body={handleEditAction}></Column>
                </DataTable>
                <Paginator
                    first={first}
                    rows={rows}
                    totalRecords={totalRoleRecords}
                    onPageChange={onPageChange}
                    className="datatable_pagination"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                />
            </div>

            {modalOpen && isMobile >= breakPoints.tablet && (
                <div className={`${modalOpen ? 'max-lg:hidden block' : 'hidden'}`}>
                    <ModalContentBlock
                        onclose={() => {
                            setModalOpen(false);
                            // setMoreDetailStepResponsive(0);
                        }}
                        isMoreClass={'w-[60%]'}
                        isModalOpen={modalOpen}
                    >
                        <AddRolePermission getRoleList={getRoleList} selectedRowData={selectedRowData} setModalOpen={setModalOpen} rolePage={page} isResponsive={false} />
                    </ModalContentBlock>
                </div>
            )}
        </div>
    );
};

export default RolesPermission;
